/**
 * Nederlandse meldingen voor Better Auth-foutcodes. Onbekende codes krijgen
 * een algemene melding; de technische tekst van de server tonen we niet.
 */
const MESSAGES: Record<string, string> = {
  INVALID_EMAIL_OR_PASSWORD: 'E-mailadres of wachtwoord klopt niet.',
  USER_ALREADY_EXISTS: 'Er bestaat al een account met dit e-mailadres.',
  USER_ALREADY_EXISTS_USE_ANOTHER_EMAIL: 'Er bestaat al een account met dit e-mailadres.',
  PASSWORD_TOO_SHORT: 'Het wachtwoord is te kort (minimaal 10 tekens).',
  PASSWORD_TOO_LONG: 'Het wachtwoord is te lang.',
  INVALID_EMAIL: 'Vul een geldig e-mailadres in.',
  INVALID_TOKEN: 'Deze herstellink is verlopen of al gebruikt. Vraag de beheerder om een nieuwe.',
};

export function authErrorMessage(error: { code?: string; status?: number } | null | undefined) {
  if (!error) return 'Er ging iets mis. Probeer het opnieuw.';
  if (error.status === 429) return 'Te veel pogingen. Wacht even en probeer het opnieuw.';
  return (error.code && MESSAGES[error.code]) ?? 'Er ging iets mis. Probeer het opnieuw.';
}
